export const PORTAL_ROUTE = "/media";
export const POST_BASIC_ROUTE = `${PORTAL_ROUTE}/post`;

export const getPostRoute = (postSlug: string) =>
  `${POST_BASIC_ROUTE}/${postSlug}`;
export const getCategoryRoute = (categorySlug: string) =>
  `${PORTAL_ROUTE}/${categorySlug}`;
